import * as Sentry from '@sentry/react';
import type { KeycloakProfile } from 'keycloak-js';

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN ?? '';

const ENVIRONMENT = import.meta.env.VITE_ENV ?? import.meta.env.MODE ?? 'development';

const sampleRate = ENVIRONMENT === 'production' ? 0.5 : 0.1;

export function initSentry() {
  if (!SENTRY_DSN) return;
  if (typeof window === 'undefined') return;

  Sentry.init({
    dsn: SENTRY_DSN,
    sendDefaultPii: true,
    tracesSampleRate: sampleRate,
    profileSessionSampleRate: sampleRate,
    environment: ENVIRONMENT,
    release: `chronomed-web@${import.meta.env.VITE_APP_VERSION ?? '1.0.0'}`,
  });
}

export function setSentryUser(user: KeycloakProfile | null) {
  if (!user) {
    Sentry.setUser(null);
    return;
  }

  Sentry.setUser({
    id: user.id,
    username: user.username,
    email: user.email,
  });
}

export function clearSentryUser() {
  Sentry.setUser(null);
}

export { Sentry };
